import {takeEvery} from 'redux-saga/effects'

import {
  STUDENT_HOMEWORK_CONFIRM_FILE,
  STUDENT_HOMEWORK_DELETE_FILE,
  STUDENT_HOMEWORK_DETAIL,
  STUDENT_HOMEWORK_LIST,
  STUDENT_HOMEWORK_MESSAGES,
  STUDENT_HOMEWORK_SEND_MESSAGE,
  STUDENT_HOMEWORK_SUBJECTS,
  STUDENT_HOMEWORK_SUBMIT,
  STUDENT_HOMEWORK_UPLOAD_URL,
} from '../../Actions/StudentHomework/ActionTypes/ApiActionTypes'
import fetchData from '../SagaHelper'

/** Parent/student homework pages (native /homework/admin, /homework/view/:id). */
function* dataSaga() {
  yield takeEvery(STUDENT_HOMEWORK_LIST, fetchData)
  yield takeEvery(STUDENT_HOMEWORK_DETAIL, fetchData)
  yield takeEvery(STUDENT_HOMEWORK_UPLOAD_URL, fetchData)
  yield takeEvery(STUDENT_HOMEWORK_CONFIRM_FILE, fetchData)
  yield takeEvery(STUDENT_HOMEWORK_SUBMIT, fetchData)
  yield takeEvery(STUDENT_HOMEWORK_DELETE_FILE, fetchData)
  yield takeEvery(STUDENT_HOMEWORK_SUBJECTS, fetchData)
  yield takeEvery(STUDENT_HOMEWORK_MESSAGES, fetchData)
  yield takeEvery(STUDENT_HOMEWORK_SEND_MESSAGE, fetchData)
}

export default dataSaga
